<page-data-manager>
  <div class="row">
    <div class="col-xs-12">
      <div class='page-header'>
        <h2>Depósitos</h2>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12">
      <div class="panel panel-default">
        <div class="panel-heading">
          Filtros
        </div>
        <div class="panel-body">
          <form>
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <label for="descricao">Descrição</label>
                <input class="form-control input-sm" ng-model="filters.descricao" type="text" id="descricao" name="descricao">
              </div>

              <div class="col-xs-12 col-md-6">
                <label>Tipo de depósito</label>
                <ui-select ng-model="filters.tipoDeposito" theme="bootstrap">
                  <ui-select-match allow-clear="true" placeholder="">{{$select.selected.descricao}}</ui-select-match>
                  <ui-select-choices repeat="tipoDeposito in tipoDepositos | filter: $select.search">
                    <span class="form-group" ng-bind-html="tipoDeposito.descricao | highlight: $select.search"></span>
                  </ui-select-choices>
                </ui-select>
              </div>

              <div class="col-xs-12 col-md-6">
                <label>&nbsp;</label><br>
                <button class="btn btn-success" ng-click="buscarClick()">
                  Buscar <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12" ng-show="depositos">
      <div class="panel panel-default">
        <div class="panel-heading">Depósitos</div>
        <div class="panel-body">
          <small ng-show="depositos.length == 0">Nenhum depósito encontrado!</small>
          <table class="table table-hover table-striped" ng-show="depositos.length > 0">
            <thead>
              <tr>
                <th class="col-xs-4">Descrição</th>
                <th class="col-xs-3">Tipo</th>
                <th class="col-xs-3">Propriedade(s)</th>
                <th class="col-xs-1">Em uso</th>
                <th class="col-xs-1"></th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="deposito in depositos track by $index">
                <td class="vertical-middle">{{deposito.descricao | capitalize}}</td>
                <td class="vertical-middle">{{deposito.tipo.descricao | capitalize}}</td>
                <td class="vertical-middle">{{deposito.propriedades | getTextItems | capitalize}}</td>
                <td class="vertical-middle">{{deposito.em_uso ? 'Sim' : 'Não'}}</td>
                <td class="vertical-middle text-right">
                  <div class="btn btn-primary btn-sm" ng-if="permissions.depositos.canRead" ng-click="show($index)" uib-tooltip="Visualizar" tooltip-placement="top">
                    <i class="glyphicon glyphicon-eye-open"></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</page-data-manager>
